function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 *  Check if  thenable
 *  (instanceof Promise doesn't respect realms)
 */
export var isThenable = function isThenable(value) {
  return _typeof(value) === 'object' && value !== null && 'then' in value && typeof value.then === 'function';
};